import http from "@/services/http"

export function accept(body) {
  return http.post(`assignment-request/accept`, body)
}
export function decline(body) {
  return http.put(`assignment-request/decline`, body)
}
export function getAssignmentTracksAll(body) {
  return http.post(`assignment-track/all`, body)
}
export function getAssignmentTrackViolation(id) {
  return http.get(`assignment-track/violation?id=${id}`)
}
export function getAssignmentTrackManyViolation(ids) {
  let apiAss = ids.map(id => 'ids=' + id)
  return http.get(`assignment-track/many/violation?${apiAss.join("&")}`)
}
export function getAssignmentTrackImage(id) {
  return http.get(`assignment-track/image-full?id=${id}`)
}

